import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ✅ Error Boundary
import ErrorBoundary from './components/ErrorBoundary';
import { AppSettingsProvider } from './context/AppSettingsContext';
import { useFavicon } from './hooks/useFavicon';
// Pages
import Dashboard from './pages/Dashboard';
import ProductsList from './pages/Products/ProductsList';
import ProductAdd from './pages/Products/ProductAdd';
import ProductEdit from './pages/Products/ProductEdit';
import ProductView from './pages/Products/ProductView';
import CategoriesList from './pages/Categories/CategoriesList';
import CategoryAdd from './pages/Categories/CategoryAdd';
import CategoryEdit from './pages/Categories/CategoryEdit';
import CategoryView from './pages/Categories/CategoryView';
import Orders from './pages/Orders';
import Customers from './pages/Customers';
import Reviews from './pages/Reviews';
import Reports from './pages/Reports';
import Banners from './pages/Banners';
import Settings from './pages/Settings';
import Login from './pages/Login';

// ✅ Common Error Page
import ErrorPage from './pages/ErrorPage';

import './styles/admin.css';

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  return children;
};
const AppWrapper = ({ children }) => {
  useFavicon();
  return children;
};
function App() {
  return (
    <BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* ✅ Error Boundary wraps everything */}
      <ErrorBoundary>
         <AppSettingsProvider>
          <AppWrapper>
        <Routes>
          {/* ✅ Error Page — Public */}
          <Route path="/error" element={<ErrorPage />} />

          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><ProductsList /></ProtectedRoute>} />
          <Route path="/products/add" element={<ProtectedRoute><ProductAdd /></ProtectedRoute>} />
          <Route path="/products/edit/:id" element={<ProtectedRoute><ProductEdit /></ProtectedRoute>} />
          <Route path="/products/view/:id" element={<ProtectedRoute><ProductView /></ProtectedRoute>} />
          <Route path="/categories" element={<ProtectedRoute><CategoriesList /></ProtectedRoute>} />
          <Route path="/categories/add" element={<ProtectedRoute><CategoryAdd /></ProtectedRoute>} />
          <Route path="/categories/edit/:id" element={<ProtectedRoute><CategoryEdit /></ProtectedRoute>} />
          <Route path="/categories/view/:id" element={<ProtectedRoute><CategoryView /></ProtectedRoute>} />
          <Route path="/orders" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
          <Route path="/banners" element={<ProtectedRoute><Banners /></ProtectedRoute>} />
          <Route path="/reviews" element={<ProtectedRoute><Reviews /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />

          {/* ✅ 404 → Error Page */}
          <Route path="*" element={<Navigate to="/error?code=404" replace />} />
        </Routes>
         </AppWrapper>
        </AppSettingsProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;